export default __webpack_public_path__ + "static/media/30005931_Can_Yetismis.4bed626e.pdf";